module.exports = __webpack_public_path__ + "static/media/great-gatsby-optimized.45c9aa78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/03-what-is-a-static-site/images/great-gatsby-optimized.jpg
// module id = 933
// module chunks = 0